// Modules
import { Button } from '@dasa-health/components-react'
import { BottomSheet } from 'components'
import React, { ReactNode, useEffect } from 'react'
import { useTracking } from 'react-tracking'
import { CustomModal } from 'redesign/components/atoms/CustomModal'

// Application
import { userDeviceDetect } from 'utils'

// Components
import { BottomSheetContent, BottomSheetTitle, BottomSheetWrapper, BottomSheetButtonWrapper } from './styles'

export interface SignUpModalProps {
    showModal: boolean
    setShowModal: (isOpen: boolean) => void
    trackEvent?: {
        event: string
        steps?: string
        path?: string
        reason?: string
        access?: string
    }
    title?: string
    children?: ReactNode
    stayConnected?: boolean
}

export const SignUpModal = ({ showModal, setShowModal, trackEvent, title, children, stayConnected }: SignUpModalProps) => {
    const { trackEvent: track } = useTracking()

    const { isPortable } = userDeviceDetect()

    useEffect(() => {
        if (trackEvent) {
            track(trackEvent)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {showModal && !isPortable && !stayConnected && (
                <CustomModal onClose={() => setShowModal(false)} open={showModal} title={title}>
                    {children}
                </CustomModal>
            )}
            {showModal && !isPortable && stayConnected && (
                <CustomModal onClose={() => setShowModal(false)} open={showModal} stayConnectedButton title={title}>
                    {children}
                </CustomModal>
            )}
            {showModal && isPortable && (
                <BottomSheet isOpen={showModal} onRequestClose={() => setShowModal(!showModal)}>
                    <BottomSheetWrapper>
                        {title && <BottomSheetTitle>{title}</BottomSheetTitle>}
                        {children && <BottomSheetContent>{children}</BottomSheetContent>}
                        {stayConnected && (
                            <BottomSheetButtonWrapper style={{ width: '100%' }}>
                                <Button onClick={() => setShowModal(false)} type="button" variant="primary" width="100%">
                                    Ok, entendi
                                </Button>
                            </BottomSheetButtonWrapper>
                        )}
                        {!stayConnected && (
                            <BottomSheetButtonWrapper>
                                <Button onClick={() => setShowModal(false)} type="button" variant="tertiary">
                                    Voltar
                                </Button>
                            </BottomSheetButtonWrapper>
                        )}
                    </BottomSheetWrapper>
                </BottomSheet>
            )}
        </>
    )
}
